import { getTime, timeDifference } from '../../utils/TimeUtils';
import Logger from '../../utils/Logger';
import { getTimelineEvents } from '../../views/timeline/data/actions';
import {
  APPOINTMENT_RESCHEDULE_SUCCESSFUL_TOAST,
  APPOINTMENT_RESCHEDULE_FAILED_TOAST,
  APPOINTMENT_RESERVATION_SUCCESSFUL_TOAST,
  APPOINTMENT_RESERVATION_FAILED_TOAST,
} from '../../definitions/ToastConstants';
import { doPushToast } from '../toasts/actions';

let createActionName = require('../util').createActionName('appointment');

const logger = Logger('appointment/actions');

export const REQUEST_APPOINTMENTS = createActionName('REQUEST_APPOINTMENTS');
export const RECEIVE_APPOINTMENTS = createActionName('RECEIVE_APPOINTMENTS');
export const REQUEST_APPOINTMENTS_FAILED = createActionName(
  'REQUEST_APPOINTMENTS_FAILED'
);
export const REQUEST_APPOINTMENT_RESCHEDULE_OPTIONS = createActionName(
  'REQUEST_APPOINTMENT_RESCHEDULE_OPTIONS'
);
export const REQUEST_APPOINTMENT_RESCHEDULE_OPTIONS_FAILED = createActionName(
  'REQUEST_APPOINTMENT_RESCHEDULE_OPTIONS_FAILED'
);
export const RECEIVE_APPOINTMENT_RESCHEDULE_OPTIONS = createActionName(
  'RECEIVE_APPOINTMENT_RESCHEDULE_OPTIONS'
);

export const REQUEST_QUEUE_APPOINTMENTS = createActionName(
  'REQUEST_QUEUE_APPOINTMENTS'
);
export const RECEIVE_QUEUE_APPOINTMENTS = createActionName(
  'RECEIVE_QUEUE_APPOINTMENTS'
);
export const REQUEST_QUEUE_APPOINTMENTS_FAILED = createActionName(
  'REQUEST_QUEUE_APPOINTMENTS_FAILED'
);

export const SHOW_QUEUE_RESERVATION_MODAL = createActionName(
  'SHOW_QUEUE_RESERVATION_MODAL'
);
export const HIDE_QUEUE_RESERVATION_MODAL = createActionName(
  'HIDE_QUEUE_RESERVATION_MODAL'
);
export const SELECT_QUEUE_RESERVATION_OPTION = createActionName(
  'SELECT_QUEUE_RESERVATION_OPTION'
);
export const REQUEST_QUEUE_RESERVATION_OPTIONS_FAILED = createActionName(
  'REQUEST_QUEUE_RESERVATION_OPTIONS_FAILED'
);

export const REQUEST_AVAILABLE_SLOTS = createActionName(
  'REQUEST_AVAILABLE_SLOTS'
);
export const RECEIVE_AVAILABLE_SLOTS = createActionName(
  'RECEIVE_AVAILABLE_SLOTS'
);
export const REQUEST_AVAILABLE_SLOTS_FAILED = createActionName(
  'REQUEST_AVAILABLE_SLOTS_FAILED'
);
export const RESET_AVAILABLE_SLOTS = createActionName('RESET_AVAILABLE_SLOTS');

export const REQUEST_APPOINTMENT_DATA = createActionName(
  'REQUEST_APPOINTMENT_DATA'
);
export const RECEIVE_APPOINTMENT_DATA = createActionName(
  'RECEIVE_APPOINTMENT_DATA'
);
export const REQUEST_APPOINTMENT_DATA_FAILED = createActionName(
  'REQUEST_APPOINTMENT_DATA_FAILED'
);

export const SELECT_RESCHEDULE_OPTION = createActionName(
  'SELECT_RESCHEDULE_OPTION'
);
export const RELEASE_RESCHEDULE_OPTION = createActionName(
  'RELEASE_RESCHEDULE_OPTION'
);
export const SHOW_RESCHEDULE_MODAL = createActionName('SHOW_RESCHEDULE_MODAL');
export const HIDE_RESCHEDULE_MODAL = createActionName('HIDE_RESCHEDULE_MODAL');
export const REQUEST_APPOINTMENT_RESCHEDULE = createActionName(
  'REQUEST_APPOINTMENT_RESCHEDULE'
);
export const REQUEST_APPOINTMENT_RESCHEDULE_FAILED = createActionName(
  'REQUEST_APPOINTMENT_RESCHEDULE_FAILED'
);
export const RECEIVE_APPOINTMENT_RESCHEDULE = createActionName(
  'RECEIVE_APPOINTMENT_RESCHEDULE'
);

export const REQUEST_APPOINTMENT_RESERVATION_CLINICS = createActionName(
  'REQUEST_APPOINTMENT_RESERVATION_CLINICS'
);
export const REQUEST_APPOINTMENT_RESERVATION_CLINICS_FAILED = createActionName(
  'REQUEST_APPOINTMENT_RESERVATION_CLINICS_FAILED'
);
export const RECEIVE_APPOINTMENT_RESERVATION_CLINICS = createActionName(
  'RECEIVE_APPOINTMENT_RESERVATION_CLINICS'
);

export const REQUEST_TIMES_FOR_CLINIC = createActionName(
  'REQUEST_TIMES_FOR_CLINIC'
);
export const RECEIVE_TIMES_FOR_CLINIC = createActionName(
  'RECEIVE_TIMES_FOR_CLINIC'
);
export const REQUEST_TIMES_FOR_CLINIC_FAILED = createActionName(
  'REQUEST_TIMES_FOR_CLINIC_FAILED'
);

export const SHOW_RESERVATION_MODAL = createActionName(
  'SHOW_RESERVATION_MODAL'
);
export const HIDE_RESERVATION_MODAL = createActionName(
  'HIDE_RESERVATION_MODAL'
);

export const REQUEST_APPOINTMENT_RESERVATION = createActionName(
  'REQUEST_APPOINTMENT_RESERVATION'
);
export const RECEIVE_APPOINTMENT_RESERVATION = createActionName(
  'RECEIVE_APPOINTMENT_RESERVATION'
);
export const REQUEST_APPOINTMENT_RESERVATION_FAILED = createActionName(
  'REQUEST_APPOINTMENT_RESERVATION_FAILED'
);

export const REQUEST_PIN_CODE_VALIDATION = createActionName(
  'SEND_PIN_CODE_VALIDATION'
);
export const RECEIVE_PIN_CODE_VALIDATION = createActionName(
  'RECEIVE_PIN_CODE_VALIDATION'
);

export const SELECT_CLINIC = createActionName('SELECT_CLINIC');
export const SELECT_REASON = createActionName('SELECT_REASON');
export const RESET_APPOINTMENT_RESERVATION = createActionName(
  'RESET_APPOINTMENT_RESERVATION'
);

export const SET_ORIGINAL_APPOINTMENT = createActionName(
  'SET_ORIGINAL_APPOINTMENT'
);

export const requestAppointments = () => ({
  type: REQUEST_APPOINTMENTS,
});

export const receiveAppointments = (data) => ({
  type: RECEIVE_APPOINTMENTS,
  data: data,
});

export const requestAppointmentsFailed = (error) => ({
  type: REQUEST_APPOINTMENTS_FAILED,
  error: error,
});

export const requestQueueAppointments = () => ({
  type: REQUEST_QUEUE_APPOINTMENTS,
});

export const receiveQueueAppointments = (data) => ({
  type: RECEIVE_QUEUE_APPOINTMENTS,
  payload: { data },
});

export const requestQueueAppointmentsFailed = (error) => ({
  type: REQUEST_QUEUE_APPOINTMENTS_FAILED,
  error: error,
});

export const requestAppointmentData = () => ({
  type: REQUEST_APPOINTMENT_DATA,
});

export const receiveAppointmentData = (data) => ({
  type: RECEIVE_APPOINTMENT_DATA,
  payload: { data },
});

export const requestAppointmentDataFailed = (error) => ({
  type: REQUEST_APPOINTMENT_DATA_FAILED,
  error: error,
});

export const requestAvailableSlots = () => ({
  type: REQUEST_AVAILABLE_SLOTS,
});

export const receiveAvailableSlots = (data) => ({
  type: RECEIVE_AVAILABLE_SLOTS,
  payload: { data },
});

export const requestAvailableSlotsFailed = (error) => ({
  type: REQUEST_AVAILABLE_SLOTS_FAILED,
  error: error,
});

export const resetAvailableSlots = () => ({
  type: RESET_AVAILABLE_SLOTS,
});

export const requestAppointmentRescheduleOptions = () => ({
  type: REQUEST_APPOINTMENT_RESCHEDULE_OPTIONS,
});

export const requestAppointmentRescheduleOptionsFailed = (error) => ({
  type: REQUEST_APPOINTMENT_RESCHEDULE_OPTIONS_FAILED,
  error: error,
});

export const receiveAppointmentRescheduleOptions = (data) => ({
  type: RECEIVE_APPOINTMENT_RESCHEDULE_OPTIONS,
  data: data,
});

export const setOriginalAppointment = (appointment) => ({
  type: SET_ORIGINAL_APPOINTMENT,
  data: appointment,
});

export const getAppointments =
  (force = false) =>
  (dispatch, getState, services) => {
    let prevState = getState().appointments;
    let { lastFetch, isFetching } = prevState;
    if (isFetching) {
      return;
    }
    dispatch(requestAppointments());
    let dataIsStale =
      force ||
      !lastFetch ||
      timeDifference(getTime(), lastFetch, 5) ||
      prevState.error;
    if (dataIsStale) {
      return services.api
        .getAppointments()
        .then((data) => {
          dispatch(receiveAppointments(data));
        })
        .catch((error) => {
          dispatch(requestAppointmentsFailed(error));
        });
    } else {
      dispatch(receiveAppointments(prevState.data));
    }
  };

export const getQueueAppointments = () => (dispatch, getState, services) => {
  dispatch(requestQueueAppointments());
  services.api
    .getQueueAppointments()
    .then((data) => {
      dispatch(receiveQueueAppointments(data));
    })
    .catch((err) => {
      dispatch(requestQueueAppointmentsFailed(err));
    });
};

export const hideQueueReservationModal = () => ({
  type: HIDE_QUEUE_RESERVATION_MODAL,
});

export const showQueueReservationModal = () => ({
  type: SHOW_QUEUE_RESERVATION_MODAL,
});

export const selectQueueReservationOption = (dateStart) => ({
  type: SELECT_QUEUE_RESERVATION_OPTION,
  dateStart,
});

export const requestQueueReservationOptionsFailed = (error) => ({
  type: REQUEST_QUEUE_RESERVATION_OPTIONS_FAILED,
  error: error,
});

export const getAvailableSlots =
  (appointmentId) => (dispatch, getState, services) => {
    let targetAppointment = null;

    dispatch(requestAppointmentData());
    services.api
      .getQueueAppointments()
      .then((queueAppointments) => {
        targetAppointment = queueAppointments.filter(
          (item) => item.appointmentId === appointmentId
        )[0];
        if (targetAppointment == null) {
          dispatch(requestAppointmentDataFailed());
          throw new Error('Target appointment not found');
        } else {
          dispatch(receiveAppointmentData(targetAppointment));
        }
      })
      .then(() => {
        dispatch(requestAvailableSlots());

        services.api
          .getAvailableSlots({
            dateStart: targetAppointment.dateStart,
            dateEnd: targetAppointment.dateEnd,
            scheduleId: targetAppointment.scheduleId,
            serviceType: targetAppointment.serviceType,
            scheduleIdList: targetAppointment.scheduleIdList,
            locationId: targetAppointment.locationId,
          })
          .then((data) => {
            dispatch(receiveAvailableSlots(data));
          })
          .catch((err) => {
            dispatch(requestAvailableSlotsFailed(err));
          });
      });
  };

export const getAppointmentRescheduleOptions =
  (appointmentId) => (dispatch, getState, services) => {
    dispatch(requestAppointmentRescheduleOptions(appointmentId));
    // appointments should be cached
    return services.api
      .getAppointments()
      .then((appointmentData) => {
        let targetAppointment = appointmentData.filter(
          (item) => item.appointmentId === appointmentId
        )[0];
        // if target appointment is not found, we cannot reschedule it. Throw exception.
        if (!targetAppointment) {
          throw new Error('Target appointment not found');
        }

        dispatch(setOriginalAppointment(targetAppointment));

        return services.api
          .getAppointmentRescheduleOptions({ payload: appointmentId })
          .then((data) => {
            // location is taken from target appointment since we have to assume the location is the same
            data = data.map((item) => ({
              ...item,
              original: false,
              location: targetAppointment.location,
            }));
            data.push({ ...targetAppointment, original: true });
            dispatch(receiveAppointmentRescheduleOptions(data));
          });
      })
      .catch((error) => {
        dispatch(requestAppointmentRescheduleOptionsFailed(error));
      });
  };

export const selectAndSubmit = (dateStart) => (dispatch) => {
  dispatch(selectRescheduleOption(dateStart));
  dispatch(showRescheduleModal());
};

export const selectRescheduleOption = (dateStart) => ({
  type: SELECT_RESCHEDULE_OPTION,
  dateStart,
});

export const releaseRescheduleOption = () => ({
  type: RELEASE_RESCHEDULE_OPTION,
});

export const showRescheduleModal = () => ({
  type: SHOW_RESCHEDULE_MODAL,
});

export const hideRescheduleModal = () => ({
  type: HIDE_RESCHEDULE_MODAL,
});

export const requestAppointmentReschedule = () => ({
  type: REQUEST_APPOINTMENT_RESCHEDULE,
});

export const requestAppointmentRescheduleFailed = (error) => ({
  type: REQUEST_APPOINTMENT_RESCHEDULE_FAILED,
  error: error,
});

export const receiveAppointmentReschedule = (data) => ({
  type: RECEIVE_APPOINTMENT_RESCHEDULE,
  data: data,
});

export const rescheduleAppointment =
  (appointment, history) => (dispatch, getState, services) => {
    function afterReceive(stayInPage) {
      dispatch(hideRescheduleModal());
      dispatch(getTimelineEvents(true));
      dispatch(getAppointments(true));
      window.scroll(0, 0);
      if (!stayInPage) {
        history.push('/timeline');
      }
    }

    dispatch(requestAppointmentReschedule());

    return services.api
      .rescheduleAppointment({ ...appointment })
      .then((data) => {
        dispatch(receiveAppointmentReschedule(data));
        dispatch(doPushToast(APPOINTMENT_RESCHEDULE_SUCCESSFUL_TOAST()));

        afterReceive(false);
      })
      .catch((error) => {
        dispatch(
          requestAppointmentRescheduleFailed(
            new Error('Failed to reschedule appointment')
          )
        );
        let errorCode = 'appointment.reschedule.failed';

        let stayInPage = error.code === 'APPOINTMENT_NOT_AVAILABLE';

        if (error.code) {
          errorCode = `appointment.reschedule.failed.${error.code}`;
        }

        dispatch(
          doPushToast(
            APPOINTMENT_RESCHEDULE_FAILED_TOAST(errorCode, stayInPage)
          )
        );
        afterReceive(stayInPage);
      });
  };

export const requestAppointmentReservationClinics = () => ({
  type: REQUEST_APPOINTMENT_RESERVATION_CLINICS,
});

export const requestAppointmentReservationClinicsFailed = (error) => ({
  type: REQUEST_APPOINTMENT_RESERVATION_CLINICS_FAILED,
  payload: { error },
});

export const receiveAppointmentReservationClinics = (data) => ({
  type: RECEIVE_APPOINTMENT_RESERVATION_CLINICS,
  payload: { data },
});

export const showReservationModal = () => ({
  type: SHOW_RESERVATION_MODAL,
});

export const hideReservationModal = () => ({
  type: HIDE_RESERVATION_MODAL,
});

export const requestTimesForClinic = () => ({
  type: REQUEST_TIMES_FOR_CLINIC,
});

export const receiveTimesForClinic = (data) => ({
  type: RECEIVE_TIMES_FOR_CLINIC,
  payload: { data },
});

export const requestTimesForClinicFailed = (error) => ({
  type: REQUEST_TIMES_FOR_CLINIC_FAILED,
  payload: { error },
});

export const getAppointmentReservationClinics =
  () => (dispatch, getState, services) => {
    return new Promise((resolve, reject) => {
      dispatch(requestAppointmentReservationClinics());
      services.api
        .getAppointmentReservationOptions()
        .then((data) => {
          resolve(dispatch(receiveAppointmentReservationClinics(data)));
        })
        .catch((err) => {
          reject(dispatch(requestAppointmentReservationClinicsFailed(err)));
        });
    });
  };

export const doGetTimesForClinic =
  (clinicId, startDate, endDate) => (dispatch, getState, services) => {
    return new Promise((resolve, reject) => {
      dispatch(requestTimesForClinic());
      services.api
        .getTimesForClinic({ clinicId: clinicId })
        .then((data) => {
          dispatch(receiveTimesForClinic(data));
        })
        .catch((error) => {
          dispatch(requestTimesForClinicFailed(error));
        });
    });
  };

export const doGetTimesForMaternityClinic =
  (clinicId, ultraType, dueDate) => (dispatch, getState, services) => {
    return new Promise((resolve, reject) => {
      dispatch(requestTimesForClinic());
      services.api
        .getTimesForMaternityClinic({ clinicId, ultraType, dueDate })
        .then((data) => {
          dispatch(receiveTimesForClinic(data));
        })
        .catch((error) => {
          dispatch(requestTimesForClinicFailed(error));
        });
    });
  };

export const selectClinic = (key) => ({
  type: SELECT_CLINIC,
  payload: { key },
});

export const selectReason = (key, dueDate) => ({
  type: SELECT_REASON,
  payload: { key, dueDate },
});

export const resetAppointmentReservation = () => ({
  type: RESET_APPOINTMENT_RESERVATION,
});

export const requestAppointmentReservation = () => ({
  type: REQUEST_APPOINTMENT_RESERVATION,
});

export const receiveAppointmentReservation = (data) => ({
  type: RECEIVE_APPOINTMENT_RESERVATION,
  payload: { data },
});

export const requestAppointmentReservationFailed = (error) => ({
  type: REQUEST_APPOINTMENT_RESERVATION_FAILED,
  payload: { error },
});

export const doReserveAppointment =
  (appointment, history) => (dispatch, getState, services) => {
    function afterReceive(stayInPage = false) {
      dispatch(hideReservationModal());
      dispatch(getTimelineEvents(true));
      dispatch(getAppointments(true));
      dispatch(resetAppointmentReservation());
      window.scroll(0, 0);
      dispatch(getQueueAppointments());
      if (!stayInPage) {
        history.push('/appointments');
      }
    }

    dispatch(requestAppointmentReservation());

    return services.api
      .reserveAppointment({ ...appointment })
      .then((data) => {
        dispatch(receiveAppointmentReservation(data));
        dispatch(doPushToast(APPOINTMENT_RESERVATION_SUCCESSFUL_TOAST()));

        afterReceive();
      })
      .catch((error) => {
        dispatch(
          requestAppointmentReservationFailed(
            new Error('Failed to reserve appointment')
          )
        );
        let errorCode = 'appointment.reservation.failed';

        let stayInPage = error.code === 'APPOINTMENT_NOT_AVAILABLE';

        if (error.code) {
          errorCode = `appointment.reservation.failed.${error.code}`;
        }

        dispatch(
          doPushToast(
            APPOINTMENT_RESERVATION_FAILED_TOAST(errorCode, stayInPage)
          )
        );
        afterReceive(stayInPage);
      });
  };

export const requestPinCodeValidation = (pinCode) => ({
  type: REQUEST_PIN_CODE_VALIDATION,
  meta: { pinCode },
});

export const receivePinCodeValidation = (isValid) => ({
  type: RECEIVE_PIN_CODE_VALIDATION,
  payload: { isValid },
});

export const validatePinCode = (pinCode) => (dispatch, getState, services) => {
  dispatch(requestPinCodeValidation(pinCode));

  services.api
    .validatePinCode({ payload: pinCode })
    .then((isValid) => dispatch(receivePinCodeValidation(isValid)));
};
